import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import EmptyView from 'components/EmptyView';

const NoUnitsConcepts = ({ unitName, resetMatchedFilter }) => (
  <EmptyView>
    <p>The selected test set did not match with any {unitName}</p>
    <p>
      Click&nbsp;
      <Button data-test="reset-button" isLink onClick={resetMatchedFilter}>
        All
      </Button>
      &nbsp;to see all the {unitName}
    </p>
  </EmptyView>
);

NoUnitsConcepts.propTypes = {
  unitName: PropTypes.string.isRequired,
  resetMatchedFilter: PropTypes.func.isRequired,
};

export default NoUnitsConcepts;
